import React, { useEffect, useState } from 'react';
import _ from "../../../utils/firebase";
import '../../../public/stylesheets/style-confirm.css';
import _Product from '../../classcomponent/modelProducts';

function DelProduct () {
    
    const delData = async () => {


        const _modelID = _Product.ModelProducts.prototype.id;

        const query = document.querySelector(`[id=data${_modelID}]`);
        query.remove();
        await _.products.doc(_modelID).delete();

        CloseFormDelData();

    }

    const CloseFormDelData = () => {

        var _form = document.getElementById('formDelDataProduct');
        _form.style.top = '-100%';
        
    }

    
    return(

        <div className='formDelDataProduct' id='formDelDataProduct'>
            <div className='box-data-search'>

                <div className='text-white'>
                    <h1 >ลบสินค้า</h1>
                </div>

                <div className='form-input'>
                    <span>ชื่อสินค้า</span>
                    <input className='form-control' id={'_delname-p'} type='text' readOnly></input>
                </div>

                <div className='form-input-btn'>
                    <div className='form-btn'>
                        <button className='btn btncreate' type='submit' onClick={delData}>ยืนยัน</button>
                        <button className='btn btncancel' onClick={CloseFormDelData}>ยกเลิก</button>
                    </div>                   
                </div> 

            </div>
        </div>
    )

}


export default DelProduct;